import {createApp} from 'vue'
import Store from 'store'
import SortingComponent from './SortingComponent'

const component = createApp(SortingComponent).use(Store)

const el = '.nlx-component--sorting-component'
const DOM = document.querySelector(el)

if(DOM){
    component.mount(el)
}

